import React, { useEffect, useState } from 'react';
import { RentalReturnStep1 } from './returnStep1';
import { RentalReturnStep2 } from './returnStep2';
import { RentalReturnStep3 } from './returnStep3';
import { RentalReturnStep3A } from './returnStep3A';
import { RentalReturnStep4 } from './returnStep4';
import { RentalReturnStep5 } from './returnStep5';

export const RentalReturn = ({
  productList,
  onNextClick,
  onPreviousClick,
  onClickDone,
  step,
}) => {
  const [productsData, setProductsData] = useState([]);
  const [selectedReturnData, setSelectedReturnData] = useState(null);
  useEffect(() => {
    setProductsData(productList);
  }, []);

  return (
    <div>
      <div>
        {step === 1 ? (
          <RentalReturnStep1
            productList={productsData}
            onClickNext={(selectedData) => {
              if (onNextClick) {
                setSelectedReturnData(selectedData);
                onNextClick(selectedData);
              }
            }}
          />
        ) : step === 2 ? (
          <RentalReturnStep3
            onClickPrevious={(selectedMethod) => {
              if (onPreviousClick) {
                onPreviousClick({ ...selectedReturnData, selectedMethod });
              }
            }}
            onClickNext={(selectedMethod) => {
              if (onNextClick) {
                setSelectedReturnData({
                  ...selectedReturnData,
                  selectedMethod,
                });
                onNextClick({ ...selectedReturnData, selectedMethod });
              }
            }}
          />
        ) : step === 3 ? (
          <RentalReturnStep3A
            onClickPrevious={(selectedMethod) => {
              if (onPreviousClick) {
                onPreviousClick({
                  ...selectedReturnData,
                  schedulePickUp: selectedMethod,
                });
              }
            }}
            onClickNext={(selectedMethod) => {
              if (onNextClick) {
                setSelectedReturnData({
                  ...selectedReturnData,
                  schedulePickUp: selectedMethod,
                });
                onNextClick({
                  ...selectedReturnData,
                  schedulePickUp: selectedMethod,
                });
              }
            }}
          />
        ) : step === 4 ? (
          <RentalReturnStep4
            onClickPrevious={(data) => {
              if (onPreviousClick) {
                onPreviousClick(data);
              }
            }}
            selectedReturnData={selectedReturnData}
            onClickNext={(selectedMethod) => {
              if (onNextClick) {
                setSelectedReturnData({
                  ...selectedReturnData,
                  summary: selectedMethod,
                });
                onNextClick({ ...selectedReturnData, summary: selectedMethod });
              }
            }}
          />
        ) : (
          <RentalReturnStep5
            onClickDone={() => {
              if (onClickDone) {
                onClickDone();
              }
            }}
          />
        )}
      </div>
    </div>
  );
};
